<div class="icon-container" matTooltip="{{ _tooltip }}">
  <span class="material-icons icon-span"> {{ _icon }} </span>
</div>
